import { create } from "zustand";

function getInitialTheme() {
  const stored = localStorage.getItem("fungistics-theme");
  if (stored) return stored;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === "dark") {
    root.classList.add("dark");
  } else {
    root.classList.remove("dark");
  }
  localStorage.setItem("fungistics-theme", theme);
}

// Shared across every useTheme() call site (AppMenu's toggle button, Analytics,
// GrowDetail's charts, …) so all of them re-render together when the theme
// changes — a plain per-component useState here would leave every instance but
// the one that owns the toggle button stale until a full page refresh.
const useThemeStore = create((set, get) => ({
  theme: getInitialTheme(),
  toggle: () => {
    const next = get().theme === "dark" ? "light" : "dark";
    applyTheme(next);
    set({ theme: next });
  },
}));

// Apply the initial theme once at module load, mirroring the old effect-on-mount
// behavior (handles the case where localStorage/system preference already says
// "dark" before any component has rendered).
applyTheme(useThemeStore.getState().theme);

export function useTheme() {
  const theme = useThemeStore((s) => s.theme);
  const toggle = useThemeStore((s) => s.toggle);
  return [theme, toggle];
}
